import type { Configuration } from '@azure/msal-browser'

const getRedirectUri = () => `${window.location.origin}/login/redirect`

const getPostLogoutRedirectUri = () =>
  import.meta.env.VITE_ENTRA_POST_LOGOUT_REDIRECT_URI?.trim() || window.location.origin

export const getMsalConfig = (): Configuration => {
  const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID?.trim()
  const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID?.trim()

  if (!clientId || !tenantId) {
    throw new Error(
      'Missing VITE_ENTRA_CLIENT_ID or VITE_ENTRA_TENANT_ID.'
    )
  }

  return {
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri: getRedirectUri(),
      postLogoutRedirectUri: getPostLogoutRedirectUri(),
    },
    cache: {
      cacheLocation: 'localStorage',
    },
  }
}
